<template>
  <div class="modal fade" id="add-cards" tabindex="-1" aria-hidden="true">
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-simple modal-upgrade-plan"
    >
      <div class="modal-content">
        <div class="modal-body">
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            id="cards-add-close"
          ></button>
          <div class="text-center">
            <h4 class="mb-8">{{ $t("batches.generate_cards") }}</h4>
          </div>
          <div class="row g-6">
            <div class="col-sm-6">
              <label class="form-label" for="">{{ $t("batches.name") }}</label>
              <input
                v-model="card.name"
                @input="validate"
                :class="{ 'is-invalid': errors.name }"
                type="text"
                class="form-control"
                aria-describedby="basic-addon34"
              />
            </div>
            <div class="col-sm-6">
              <label class="form-label" for="">{{
                $t("batches.prefix")
              }}</label>
              <input
                v-model="card.prefix"
                type="text"
                class="form-control"
                aria-describedby="basic-addon34"
                oninput="this.value=this.value.replace(/[^a-zA-Z0-9_.\-@\s]/g,'');"
                dir="ltr"
                placeholder="Ex: 200M_"
              />
            </div>
            <div class="col-sm-6">
              <label class="form-label" for="selectpickerBasic">{{
                $t("batches.profile")
              }}</label>
              <select
                v-model="card.profile_id"
                @change="
                  validate();
                  fix_date();
                  update_price();
                "
                :class="{ 'is-invalid': errors.profile }"
                class="form-select w-100"
                data-style="btn-default"
              >
                <option
                  v-for="profile in profiles"
                  v-bind:key="profile.id"
                  :value="profile.id"
                  >{{ profile.name }}</option
                >
              </select>
            </div>
            <div class="col-sm-6">
              <label class="form-label" for="selectpickerBasic">{{
                $t("batches.chars")
              }}</label>
              <select
                class="form-select w-100"
                @change="validate()"
                v-model="card.chars"
                data-style="btn-default"
              >
                <option value="alpha">{{ $t("batches.alpha") }}</option>
                <option value="numeric">{{ $t("batches.numeric") }}</option>
              </select>
            </div>
            <div class="col-sm-4 col-6">
              <label class="form-label" for="">{{
                $t("batches.username_length")
              }}</label>
              <input
                type="number"
                class="form-control"
                v-model="card.username_length"
                :class="{ 'is-invalid': errors.username_length }"
                @input="validate"
                aria-describedby="basic-addon34"
                placeholder="Username Length"
              />
            </div>
            <div class="col-sm-4 col-6">
              <label class="form-label" for="">{{
                $t("batches.password_length")
              }}</label>
              <div class="input-group">
                <div class="input-group-text">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="card.password_enabled"
                    @change="validate"
                  />
                </div>
                <input
                  type="number"
                  class="form-control"
                  :disabled="!card.password_enabled"
                  :class="{ 'is-invalid': errors.password_length }"
                  v-model="card.password_length"
                  @input="validate"
                  placeholder="Password Length"
                />
              </div>
            </div>
            <div class="col-sm-4 col-6">
              <label class="form-label" for="">{{
                $t("batches.quantity")
              }}</label>
              <input
                type="number"
                class="form-control"
                placeholder="Quantity"
                :class="{ 'is-invalid': errors.quantity }"
                v-model="card.quantity"
                @input="validate"
              />
            </div>
            <div v-if="user.type != 'reseller'" class="col-sm-6 col-6">
              <label class="form-label" for="">{{
                $t("batches.sessions")
              }}</label>
              <input
                type="number"
                class="form-control"
                v-model="card.allowed_sessions"
                placeholder="Allowed Sessions"
                :class="{ disabled: card.is_mac }"
              />
            </div>
            <div class="col-sm-6">
              <label class="form-label" for="">{{ $t("batches.price") }}</label>
              <input
                type="number"
                class="form-control"
                v-model="card.price"
                placeholder="Price"
              />
            </div>
            <div class="col-sm-12">
              <label class="form-label" for="">{{
                $t("messages.batches.is_mac")
              }}</label>
              <div class="row">
                <div class="">
                  <div class="form-check custom-option custom-option-basic">
                    <label
                      class="form-check-label custom-option-content"
                      for="appallowed"
                    >
                      <input
                        name="apppermissions"
                        class="form-check-input"
                        type="checkbox"
                        v-model="card.is_mac"
                        @input="validate"
                      />
                      <span class="custom-option-header">
                        <span class="h6 mb-0 d-flex align-items-center"
                          ><i class="ti ti-world-check me-1"></i
                          >{{ $t("batches.is_mac") }}</span
                        >
                      </span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="text-danger">
              <div v-if="errors.name">{{ errors.name }}</div>
              <div v-if="errors.profile">{{ errors.profile }}</div>
              <div v-if="errors.username_length">
                {{ errors.username_length }}
              </div>
              <div v-if="errors.password_length">
                {{ errors.password_length }}
              </div>
              <div v-if="errors.chars">{{ errors.chars }}</div>
              <div v-if="this.user.type == 'reseller'">
                <div>
                  {{
                    $t("control.cost", {
                      cost: price * card.quantity + " " + settings.currency,
                    })
                  }}
                </div>
                <div
                  :class="{
                    'text-danger': user.money - price * card.quantity < 0,
                  }"
                >
                  {{
                    $t("control.money_left", {
                      original: user.money,
                      left:
                        user.money -
                        price * card.quantity +
                        " " +
                        settings.currency,
                    })
                  }}
                </div>
              </div>
            </div>
            <div class="col-12 d-flex justify-content-end">
              <button
                class="btn btn-success"
                :disabled="
                  !validated ||
                    (this.user.money - this.price * this.card.quantity < 0 &&
                      this.user.type == 'reseller')
                "
                @click.prevent="store"
              >
                {{ $t("batches.add") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters, mapState } from "vuex";
import moment from "moment";
export default {
  name: "AddCards",
  computed: {
    ...mapGetters(["user", "settings"]),
  },
  props: {
    copyCard: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      error: "",
      message: "",
      card: {
        name: "",
        quantity: 1,
        price: 0,
        prefix: "",
        chars: "numeric",
        profile_id: null,
        username_length: 6,
        password_length: 3,
        allowed_sessions: 1,
        fixed_expiration: null,
        is_mac: false,
        password_enabled: true,
      },
      errors: {
        name: null,
        profile: null,
        username_length: null,
        password_length: null,
        chars: null,
      },
      loading: false,
      profiles: null,
      validated: false,
      date_format: (date) => {
        const day = date.getDate();
        const month = date.getMonth() + 1;
        const year = date.getFullYear();
        const hour = date.getHours();
        const minute = date.getMinutes();

        return `${day}-${month}-${year} ${hour}:${minute}`;
      },
      price: 0,
    };
  },
  async created() {
    this.loading = true;
    await this.fetchProfiles();
    this.loading = false;
    if (this.copyCard) {
      this.card = this.copyCard;
      this.card.name = "";
      this.card.id = null;
      this.card.profile_id = this.copyCard.profile.id;
      this.card.chars = "numeric";
    }
  },
  methods: {
    async store() {
      this.loading = true;
      if (!this.card.password_enabled) {
        this.card.password_length = 0;
      }
      const response = await axios.post("/cards", this.card);
      if (response.status == 200) {
        this.loading = false;
        document.getElementById("cards-add-close").click();
        this.$notify({
          text: "Cards Batch Generated Successfully",
          type: "success",
        });
        this.$emit("updated");
      } else if (response.status == 210) {
        this.loading = false;
        if (response.data.error == "cards_name_already_exists") {
          this.errors.name = this.$t("errors.batches.name_taken");
          this.validated = false;
        }
        if (response.data.error == "chars") {
          this.errors.chars = this.$t("errors.batches.chars");
          this.validated = false;
        }
        if (response.data.error == "not_enough_chards") {
          this.errors.chars = this.$t("errors.batches.not_enough_chars");
          this.validated = false;
        }
      }
    },
    async fetchProfiles() {
      const response = await axios.get(
        "/profiles?itr=1&type=prepaid&rows=1000000"
      );
      if (response.status == 200) this.profiles = response.data.data;
    },
    changeProfile(profile_id) {
      this.account.profile_id = profile_id;
    },
    fix_date() {
      let profile = this.profiles.filter((profile) => {
        return profile.id === this.card.profile_id;
      });
      profile = profile[0];
      this.card.fixed_expiration = moment().add(
        profile.expiration_value,
        profile.expiration_unit
      );
      this.card.fixed_expiration.hours(0);
      this.card.fixed_expiration.minutes(0);
    },
    update_price() {
      let profile = this.profiles.filter((profile) => {
        return profile.id == this.card.profile_id;
      });
      profile = profile[0];
      this.price = profile.price;
      this.card.price = profile.price;
    },
    fetchCard(id) {
      if (this.card.expires_at) {
        this.card.fixed_expiration = moment(this.account.expires_at);
      }
    },
    validate() {
      this.validated = true;
      this.errors.name = null;
      this.errors.profile = null;
      this.errors.username_length = null;
      this.errors.password_length = null;
      if (!this.card.profile_id) {
        this.validated = false;
        this.errors.profile = this.$t("errors.accounts.select_profile");
      }
      if (this.card.name == "") {
        this.validated = false;
        this.errors.name = this.$t("errors.batches.name_empty");
      }
      if (this.card.chars == "numeric" && this.card.username_length < 6) {
        this.validated = false;
        this.errors.username_length = this.$t(
          "errors.batches.username_length_6"
        );
      }
      if (this.card.password_length < 0) this.card.password_length = 0;
      if (this.card.password_length < 3 && this.card.password_enabled) {
        this.validated = false;
        this.errors.password_length = this.$t(
          "errors.batches.password_length_3"
        );
      }
      if (this.card.username_length < 8 && !this.card.password_enabled) {
        this.validated = false;
        this.errors.username_length = this.$t(
          "errors.batches.username_length_8"
        );
      }
      if (
        this.user.money - this.price * this.card.quantity < 0 &&
        this.user.type == "reseller"
      ) {
        this.validated = false;
      }
      if (this.card.is_mac) {
        this.card.allowed_sessions = 1;
      }
    },
  },
};
</script>
